export default __webpack_public_path__ + "static/media/Whack_a_Word_instructions.c4e766f4.png";